// Classes.
import {BaseComponentLocator} from './base.component-locator';

// Interfaces.
import {ComponentLocatorInterface} from '../interfaces/component-locator.interface';


export class StringLocatorComponent extends BaseComponentLocator implements ComponentLocatorInterface {

  public constructor(protected _value: string = null) {
    super();
  };

  public toString(): string {
    return this._value !== null ? this._value : 'empty';
  }

  /**
   * value setter/getter.
   */
  set value(value: string) {
    this._value = value;
  }

  get value(): string {
    return this._value;
  }
}

